module.exports = __webpack_public_path__ + "img/page-bg.87a91406.jpg";